import {withAppContext} from "../../util/withAppContext";
import withNavigate from "../../util/useNavigate";
import withBreakpoint from "../../util/withBreakpoint";
import {EnlilTable} from "../EnlilTable";

class ProjectMilestoneSessionTable extends EnlilTable {
}

export default withNavigate(withAppContext(withBreakpoint(ProjectMilestoneSessionTable)));